import apiClient from "../config/api";

/**
 * Get dashboard data for a given month
 * @param {string} month - Month in YYYY-MM format (e.g. "2026-02")
 * @returns {Promise} API response with dashboard data
 */
export const getDashboard = async (month) => {
  try {
    const response = await apiClient.get("/dashboard", {
      params: { month },
    });
    return response.data;
  } catch (error) {
    console.error("getDashboard error:", error);
    throw error;
  }
};
